import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import GrantsByState from "@/pages/GrantsByState";

export const Route = createFileRoute("/grants/$state")({
  head: ({ params }) => seoHead(`/grants/${params.state}`),
  component: GrantsByState,
});
